import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const { TextArea } = Input;

const TextareaItem = (props) => {
    const { title, placeholder, min_rows, max_rows, container_class, title_class, textarea_class,name, value, onChange } = props;

    return (
        <div className={container_class}>
            {
                title &&
                <p className={`ori-b-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
            }
            <TextArea placeholder={placeholder} className={textarea_class} autosize={{ minRows: min_rows, maxRows: max_rows }} name={name} value={value} onChange={onChange} />
        </div>
    );
};

TextareaItem.propTypes = {
    title: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    min_rows: PropTypes.number,
    max_rows: PropTypes.number,
    onChange: PropTypes.func,
    container_class: PropTypes.string,
    textarea_class: PropTypes.string,
    title_class: PropTypes.string,
};

TextareaItem.defaultProps = {
    min_rows: 2,
    max_rows: 4,
    container_class: "ori-tb-pad-5",
    textarea_class: ""
};

export default TextareaItem;


// WEBPACK FOOTER //
// ./src/components/form/textareaitem/index.js